// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nGM6","col":"styles_col__7GWtR"};